import { useContext } from "react";
import { AppContext, IAppContextState } from "../../../App";
import { Badge, Modal } from "flowbite-react";
import { PlateShareGallery } from "../../../components/image-gallery/plateshare-gallery";
import { Link } from "react-router-dom";

export const PlateShareModalData = () => {
  const { plateShareModalState } = useContext<IAppContextState | any>(
    AppContext
  );
  const [isOpenPlateShareModal, setOpenPlateShareModal] = plateShareModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenPlateShareModal}
      onClose={() => setOpenPlateShareModal(false)}
    >
      <Modal.Header>WarmPaws Homepage</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <PlateShareGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name:{" "}
                <span className="text-amber-500">
                  Plate Share - Share your foods
                </span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex flex-wrap">
                <Badge color="red" className="me-2 my-1">
                  React
                </Badge>
                <Badge color="red" className="me-2 my-1">
                  Firebase Auth
                </Badge>
                <Badge color="green" className="me-2 my-1">
                  MongoDB
                </Badge>
                <Badge color="gray" className="me-2 my-1">
                  ExpressJS
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  TailwindCSS
                </Badge>
                <Badge color="yellow" className="my-1">
                  daisyUI
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    PlateShare lets you share your extra meals with others,
                    turning food surplus into moments of joy. Connect with your
                    community, reduce waste, and spread kindness one plate at a
                    time.
                  </p>
                  <ul className="list-disc mt-4 ms-5">
                    <li>
                      Post, browse, and request meals with real-time tracking of
                      availability and status.
                    </li>
                    <li>
                      Secure user authentication with Firebase and smooth
                      navigation through-out the app with dynamic UI tools.
                    </li>
                    <li>
                      Connect donors and receivers seamlessly through a
                      responsive, community-focused interface.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://plate-share.netlify.app/"
                className="text-amber-500 hover:text-amber-700 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
